import "./confirm.css";

const ConfirmationDetails = ({
  travelReimbursement,
  housingAccomadations,
  status,
  housing_link,
  housing_date,
  showConfirmationAction,
}) => {
  const showResourceLinks = ["accepted", "waitlist_accepted", "confirmed"].includes(
    status
  );
  let housingDueDate = "2024-05-20";

  housingDueDate = new Date(housing_date + "T00:00:00Z");

  const formattedHousingDueDate = housingDueDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });

  if (travelReimbursement && housingAccomadations) {
    return (
      <div className="conf-details">
        <h3 className="conf-details-h3">Confirmation Details</h3>
        <p>
          We are able to provide you a sleeping arrangement in a shared
          Princeton dormitory. Please fill out the housing accommodation form
          below by {formattedHousingDueDate} at 11:59 PM. In addition, we are
          able to reimburse you up to $100 for your travels. You must have an
          active Zelle account to receive your reimbursement.
        </p>
        <a
          className="ha-form"
          href={housing_link}
          rel="noopener noreferrer"
          target="_blank"
        >
          Housing Accommodation Form
        </a>

        {showResourceLinks && (
          <>
            {showConfirmationAction ? (
              <p>
                Confirming your acceptance below acknowledges and accepts the
                above information.
              </p>
            ) : (
              <p>
                We are excited to welcome you to HackPrinceton.
              </p>
            )}
            <p>
              We are estimating that check-in will begin around 4-5pm, and the
              closing ceremony will end no later than 4:30pm! Please plan your
              flights accordingly with at least a few hours of wiggle room after
              the closing ceremony!
            </p>
            {status !== "confirmed" && (
              <p>Discord and the hacker packet will be available in your portal after you confirm attendance.</p>
            )}
          </>
        )}
      </div>
    );
  } else if (travelReimbursement && !housingAccomadations) {
    return (
      <div className="conf-details">
        <h3 className="conf-details-h3">Confirmation Details</h3>
        <p>
          We are able to reimburse you up to $100 for your travels! You must
          have an active Zelle account to receive your reimbursement. If you
          also applied for housing, we are unfortunately unable to accommodate
          you.
        </p>
        {showResourceLinks && (
          <>
            {showConfirmationAction ? (
              <p>
                Confirming your acceptance below acknowledges and accepts the
                above information.
              </p>
            ) : (
              <p>
                We are excited to welcome you to HackPrinceton.
              </p>
            )}
            <p>
              We are estimating that check-in will begin around 4-5pm, and the
              closing ceremony will end no later than 4:30pm! Please plan your
              flights accordingly with at least a few hours of wiggle room after
              the closing ceremony!
            </p>
            {status !== "confirmed" && (
              <p>Discord and the hacker packet will be available in your portal after you confirm attendance.</p>
            )}
          </>
        )}
      </div>
    );
  } else if (!travelReimbursement && housingAccomadations) {
    return (
      <div className="conf-details">
        <h3 className="conf-details-h3">Confirmation Details</h3>
        <p>
          We are able to provide you a sleeping arrangement in a shared
          Princeton dormitory! Please fill out the housing accommodation form
          below by {formattedHousingDueDate} at 11:59 PM. If you also applied
          for travel reimbursement, we are unfortunately unable to reimburse
          you.
        </p>
        <a
          className="ha-form"
          href={housing_link}
          rel="noopener noreferrer"
          target="_blank"
        >
          Housing Accommodation Form
        </a>
        {showResourceLinks && (
          <>
            {showConfirmationAction ? (
              <p>
                Confirming your acceptance below acknowledges and accepts the
                above information.
              </p>
            ) : (
              <p>
                We are excited to welcome you to HackPrinceton.
              </p>
            )}
            <p>
              We are estimating that check-in will begin around 4-5pm, and the
              closing ceremony will end no later than 4:30pm! Please plan your
              flights accordingly with at least a few hours of wiggle room after
              the closing ceremony!
            </p>
            {status !== "confirmed" && (
              <p>Discord and the hacker packet will be available in your portal after you confirm attendance.</p>
            )}
          </>
        )}
      </div>
    );
  } else {
    return (
      <div className="conf-details">
        <h3 className="conf-details-h3">Confirmation Details</h3>
        <p>
          If you applied for housing and/or travel reimbursements, we are
          unfortunately unable to provide you with either.
        </p>
        {showResourceLinks && (
          <>
            {showConfirmationAction ? (
              <p>
                Confirming your acceptance below acknowledges and accepts the
                above information.
              </p>
            ) : (
              <p>
                We are excited to welcome you to HackPrinceton.
              </p>
            )}
            <p>
              We are estimating that check-in will begin around 4-5pm, and the
              closing ceremony will end no later than 4:30pm! Please plan your
              flights accordingly with at least a few hours of wiggle room after
              the closing ceremony!
            </p>
            {status !== "confirmed" && (
              <p>Discord and the hacker packet will be available in your portal after you confirm attendance.</p>
            )}
          </>
        )}
      </div>
    );
  }
};

export default ConfirmationDetails;
